{
  "collapse": "כווץ",
  "expand": "הרחב"
}
